import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HisFileUploadCoreModule } from './../upload/his-file-upload-core.module';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { ListboxModule } from 'primeng/listbox';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { Textarea } from 'primeng/inputtextarea';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';

import { HisCoreSharedModule } from '../core/his-core-shared.module';
import { HisInputCoreModule } from '../input/his-input-core.module';
import { HisStructureSharedModule } from '../structure/his-structure-shared.module';
import { HisJobConfigurationComponent } from './component/job-config/his-job-configuration.component';
import { HisJobSettingComponent } from './component/job-config/his-job-setting.component';
import { HisLongTextJobSettingComponent } from './component/job-config/job-settings/his-long-text-job-setting.component';
import { HisShortTextJobSettingComponent } from './component/job-config/job-settings/his-short-text-job-setting.component';
import { HisJobDetailsComponent } from './component/job-details/his-job-details.component';
import { HisJobStarterComponent } from './component/job-starter/his-job-starter.component';
import { HisIntegerJobSettingComponent } from './component/job-config/job-settings/his-integer-job-setting.component';
import { HisDoubleJobSettingComponent } from './component/job-config/job-settings/his-double-job-setting.component';
import { HisHtmlTextJobSettingComponent } from './component/job-config/job-settings/his-html-text-job-setting.component';
import { HisSelectOneJobSettingComponent } from './component/job-config/job-settings/his-select-one-job-setting.component';
import { HisSelectManyJobSettingComponent } from './component/job-config/job-settings/his-select-many-job-setting.component';
import { HisFileJobSettingComponent } from './component/job-config/job-settings/his-file-job-setting.component';
import { HisBooleanJobSettingComponent } from './component/job-config/job-settings/his-boolean-job-setting.component';
import { HisDateJobSettingComponent } from './component/job-config/job-settings/his-date-job-setting.component';

@NgModule( {
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HisCoreSharedModule,
        HisStructureSharedModule,
        HisInputCoreModule,
        HisFileUploadCoreModule,

        // PrimeNg
        PanelModule,
        CalendarModule,
        AutoCompleteModule,
        ListboxModule,
        Textarea,
        ProgressSpinnerModule,
        DialogModule,
        TableModule,
        EditorModule,
    ],
    declarations: [
        HisJobStarterComponent,
        HisJobDetailsComponent,
        HisJobSettingComponent,
        HisJobConfigurationComponent,

        HisShortTextJobSettingComponent,
        HisLongTextJobSettingComponent,
        HisHtmlTextJobSettingComponent,
        HisIntegerJobSettingComponent,
        HisDoubleJobSettingComponent,
        HisFileJobSettingComponent,
        HisBooleanJobSettingComponent,
        HisSelectOneJobSettingComponent,
        HisSelectManyJobSettingComponent,
        HisDateJobSettingComponent,

    ],
    exports: [
        HisJobStarterComponent
    ]
} )
export class HisJobsSharedModule { }
